<template>
  <header class="mdl-layout__header mdl-color--grey-50 mdl-color-text--grey-800 is-casting-shadow">
    <div class="mdl-layout__header-row">
      <span class="mdl-layout-title">{{ title }}</span>
      <div class="mdl-layout-spacer"></div>
      <!-- <div class="mdl-textfield mdl-js-textfield mdl-textfield--expandable">
        <label class="mdl-button mdl-js-button mdl-button--icon" for="search">
          <i class="material-icons">search</i>
        </label>
        <div class="mdl-textfield__expandable-holder">
          <input class="mdl-textfield__input" type="text" id="search">
          <label class="mdl-textfield__label" for="search">Buscar...</label>
        </div>
      </div> -->
      <!-- <button class="mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon" id="hdrbtn">
        <i class="material-icons">more_vert</i>
      </button> -->
      <!-- <form @submit.stop="buscarAuditoria">
        <div class="mdl-textfield mdl-js-textfield mdl-textfield--expandable">
          <label class="mdl-button mdl-js-button mdl-button--icon" for="buscar-auditoria">
            <i class="material-icons">search</i>
          </label>
          <div class="mdl-textfield__expandable-holder">
            <input class="mdl-textfield__input" type="text" id="buscar-auditoria">
            <label class="mdl-textfield__label" for="sample-expandable">Buscar auditoría...</label>
          </div>
        </div>
      </form> -->

      <button class="mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon"
        @click="refresh">
        <i class="material-icons">refresh</i>
      </button>
      <!-- <ul class="mdl-menu mdl-js-menu mdl-js-ripple-effect mdl-menu--bottom-right" for="hdrbtn">
        <li class="mdl-menu__item">About</li>
        <li class="mdl-menu__item">Contact</li>
        <li class="mdl-menu__item">Legal information</li>
      </ul> -->
    </div>
  </header>
</template>

<script>
export default {
  data () {
    return {
      title: '',
      endpoint: ''
    }
  },
  methods: {
    show (title) {
      this.title = title
    },
    asignRefresh (request) {
      this.refresh = request
    },
    refresh () {},
    destroy () {
      this.refresh = () => {}
    },
    buscarAuditoria (event) {
      const form = event.currentTarget,
            value = form['buscar-auditoria'].value
    }
  },
  mounted () {
    this.$title.show = this.show
    this.$endpoint.refresh = this.asignRefresh
    this.$endpoint.destroy = this.destroy
    componentHandler.upgradeElement(this.$el)
  }
}
</script>

<style lang="css" scoped>
  .mdl-textfield {
    padding: 15px 0;
  }

  .mdl-textfield__label {
    top: 8px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?d48b837a